<template>
  <div>
    <component v-bind:is="currentStepComponent" v-if="!finish"></component>
    <component v-bind:is="currentSubStepComponent" v-if="!finish"></component>
    <finish v-if="finish"></finish>

    <div v-if="$store.state.isLoading" class="loading">
      <p>Ładowanie...</p>
    </div>
    
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import {
  mapMutations
} from 'vuex'

import {
  mapActions
} from 'vuex'

import finish from '../components/finish.vue';

export default {
  name: 'app',
  components: {
    'finish': finish
  },
  computed: {
    currentStepComponent: {
      get() {
        return this.$store.state.currentStepComponent
      },
      set(state, payload) {
        this.$store.commit('setCurrentStepComponent', payload)
      }
    },
    currentSubStepComponent: {
      get() {
        return this.$store.state.currentSubStepComponent
      },
      set(state, payload) {
        this.$store.commit('setCurrentSubStepComponent', payload)
      }
    },
    finish: {
      get() {
        return this.$store.state.finish
      },
      set(state, payload) {
        this.$store.commit('setFinish', payload)
      }
    }
  },
  mounted(){
    this.$store.dispatch('paseQueryString')
  }
}
</script>

<style lang="scss">
@import "@/assets/fonts/stylesheet.scss";
body,
html {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-family: 'Roboto', Arial;
    color: #2C2C2C;
}
*,
*::after,
*::before {
    box-sizing: border-box;
}

#app {
    width: 100vw;
    max-width: 960px;
    margin: 0 auto;
}
.c-step {
    background: url("../assets/home.jpg");
    background-size: 90%;
    background-repeat: no-repeat;
    background-position: center;
    height: 100vh;
    padding: 2rem 1rem 1rem;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    &-ask {
        padding: 1rem 0;
    }
    &-option {
        padding: 0.5rem 1rem;
        text-align: center;
        margin-bottom: 0.5rem;
        &.selected {
            border: 1px solid #070A4F;
        }
    }
}
.c-substep {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &-popup {
        max-width: 780px;
        width: 90%;
        background-color: #fff;
        padding: 1rem;
        border-radius: 0.8rem;
        p {
            text-align: center;
            margin-bottom: 1.5rem;
            font-size: 0.85rem;
        }
    }
}
input {
    border: 0;
    border-bottom: 1px solid #B1B1B1;
    display: block;
    width: 100%;
    font-size: 1rem;
    color: #2C2C2C;
    padding: 0.5rem 0 0.5rem 1rem;
    margin-top: 1rem;
}
button {
    color: #fff;
    background-color: #070A4F;
    border-radius: 0.8rem;
    border: 0;
    display: block;
    width: 100%;
    margin-bottom: 1rem;
    font-size: 1rem;
    padding: 0.9rem;
    line-height: 1;
    &.white {
        background-color: #fff;
        border: 1px solid #070A4F;
        color: #070A4F;
    }
}
.vdp-datepicker {
    width: 100%;
}
.vdp-datepicker__calendar {
    width: 100% !important;
    max-width: 314px;
    display: block;
    position: relative;
    box-shadow: 0 0 25px -13px rgba(0,0,0,0.5);
    border: 0 !important;
    border-radius: 0.8rem;
    padding: 1rem;
    margin: 1rem auto;
}
.cell.day.selected {
    border-radius: 50%;
    background-color: #070A4F !important;
    color: #fff !important;
    font-weight: bold;
}
.cell.day {
    width: 2.5rem !important;
    height: 2.5rem !important;
    color: #2C2C2C !important;
    &.disabled{
      color: #B1B1B1!important;
    }
}
.day-header {
    color: #B1B1B1;
    font-size: 1rem;
}
.vue__time-picker.time-picker {
    width: 100% !important;
    display: block;
    // margin: 1.5rem 1rem;
    margin-right: 1rem;
}
.vdatetime-input {
    margin-right: 1rem;
    margin-top: 0;
    width: calc(100% - 1rem);
}
.vdatetime-popup__header {
    background-color: #070A4F !important;
}
input:focus::-webkit-input-placeholder  {color:transparent;}
input:focus::-moz-placeholder   {color:transparent;}
input:-moz-placeholder   {color:transparent;}
.flex-row{
  display:flex;
  justify-content: space-between;
}
.flex-item{
  width: 100%;
}
.loading{
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  z-index: 99999;
  text-align: center;
}
</style>
